import React from "react";

import getMentionLink from "../getMentionLink";

const findMentionEntities = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges(character => {
    const entityKey = character.getEntity();

    return entityKey !== null && contentState.getEntity(entityKey).getType() === "MENTION";
  }, callback);
};

const Mention = ({ children }) => <span className="chq-edi--mn">{children}</span>;

export default props => ({
  strategy: findMentionEntities,
  component: Mention,
  props
});
